import { render, staticRenderFns } from "./LogRecord.vue?vue&type=template&id=13fab19c&"
import script from "./LogRecord.vue?vue&type=script&lang=js&"
export * from "./LogRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fab19c')) {
      api.createRecord('13fab19c', component.options)
    } else {
      api.reload('13fab19c', component.options)
    }
    module.hot.accept("./LogRecord.vue?vue&type=template&id=13fab19c&", function () {
      api.rerender('13fab19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/LogRecord.vue"
export default component.exports